import classnames from 'classnames';
const { useState, useEffect, useRef } = wp.element;

const { __ } = wp.i18n;
function StyleGrid(props) {

	const {
		col_style,
		content_visibility,
		content_limit,
		data,
		slider_options,
		sliderSettings,
		col_xl,
		col_lg,
		col_md,
		col_sm,
		col_mobile,
	} = props;

	const gridContainerClassNames = classnames([
		'swiper',
		'rtcl-gb-slider-pagination-style-' + slider_options["dotStyle"],
		'rtcl-gb-slider-btn-style-' + slider_options["arrowPosition"],
		'rtcl-gb-grid-view',
		'rtcl-gb-grid-style-' + col_style['style']

	]);

	const itemContainerClassNames = classnames([
		content_visibility["thumb_position"] === "left" ? "rtcl-flex" : ""
	])
	const actionBTNWrapClass = classnames([
		'rtcl-show-lg',
		'rtcl-gb-meta-buttons-wrap',
		content_visibility["actionLayout"],
		'meta-button-count-3',
	])

	const sliderReff = useRef(null);
	const rtcl_gb_caterory_slider = function (sliderE, sliderOptions) {
		let options = Object.assign({}, sliderOptions);
		if (sliderE.swiper) {
			sliderE.swiper.destroy();
		}
		new Swiper(sliderE, options);
	};
	useEffect(() => {
		rtcl_gb_caterory_slider(sliderReff.current, sliderSettings);
	}, [slider_options, col_xl, col_lg, col_md, col_sm, col_mobile, content_visibility]);

	return [
		data.length ? (
			<div className="rtcl rtcl-gb-block rtcl-gb-slider-main-wrap">
				<div ref={sliderReff} className={gridContainerClassNames} >
					<div className="swiper-wrapper">
						{data.map((listing, index) => (
							<div className="swiper-slide" key={index}>
								<div className={[Object.values(listing.classes).join(" "), itemContainerClassNames]}>

									{(content_visibility["thumbnail"] && listing.thumbnail) ? (
										<div className="listing-thumb">
											<a href={listing.post_link} className="rtcl-media" dangerouslySetInnerHTML={{ __html: listing.thumbnail }}></a>
											{content_visibility["sold"] && listing.sold ? <span dangerouslySetInnerHTML={{ __html: listing.sold }}></span> : ''}
											<div className={actionBTNWrapClass}>
												{(content_visibility["favourit_btn"] && listing.favourite_link) ?
													<div className="rtcl-gb-button" dangerouslySetInnerHTML={{ __html: listing.favourite_link }}></div> : ''}
												{(content_visibility["quick_btn"] && listing.quick_view) ?
													<div className="rtcl-gb-button" dangerouslySetInnerHTML={{ __html: listing.quick_view }}></div> : ''}
												{(content_visibility["compare_btn"] && listing.compare) ?
													<div className="rtcl-gb-button" dangerouslySetInnerHTML={{ __html: listing.compare }}></div> : ''}
											</div>
										</div>
									) : ''}

									<div className="item-content">

										{(content_visibility["badge"] && listing.badges) ? (
											<div className="listing-badge-wrap" dangerouslySetInnerHTML={{ __html: listing.badges }}></div>
										) : ''}

										{(content_visibility["category"] && listing.categories) ? (
											<div className='listing-cat' dangerouslySetInnerHTML={{ __html: listing.categories }}></div>
										) : ''}

										{(content_visibility["title"] && listing.title) ? (
											<h3 className="listing-title"><a href={listing.post_link}>{listing.title}</a></h3>
										) : ''}

										{(content_visibility["price"] && listing.price) ? (
											<div className="item-price listing-price" dangerouslySetInnerHTML={{ __html: listing.price }}></div>
										) : ''}

										<ul className="rtcl-listing-meta-data">
											{(content_visibility["listing_type"] && listing.listing_type) ? (
												<li className="listing-type"><i className="rtcl-icon rtcl-icon-tags"></i>{listing.listing_type}</li>
											) : ''}
											{(content_visibility["date"] && listing.time) ? (
												<li className="updated"><i className="rtcl-icon rtcl-icon-clock"></i>{listing.time}</li>
											) : ''}
											{(content_visibility["author"] && listing.author) ? (
												<li className="author"><i className="rtcl-icon rtcl-icon-user"></i>{listing.author}</li>
											) : ''}
											{(content_visibility["location"] && listing.locations) ? (
												<li className="rt-location"><i className="rtcl-icon rtcl-icon-location"></i><span dangerouslySetInnerHTML={{ __html: listing.locations }}></span></li>
											) : ''}
											{(content_visibility["view"] && listing.views) ? (
												<li className="rt-views"><i className="rtcl-icon rtcl-icon-eye"></i>{listing.views} {__("views", "classified-listing")}</li>
											) : ''}
										</ul>

										{(content_visibility["grid_content"] && listing.excerpt) ? (
											<p className="rtcl-excerpt" dangerouslySetInnerHTML={{ __html: listing.excerpt.split(' ', content_limit).join(' ') }}></p>
										) : ''}

									</div>

								</div>
							</div>
						))}
					</div>
					{slider_options["arrowNavigation"] &&
						<>
							<span className="rtcl-gb-slider-btn button-left rtcl-icon-angle-left"></span>
							<span className="rtcl-gb-slider-btn button-right rtcl-icon-angle-right"></span>
						</>
					}
					{slider_options["dotNavigation"] && <div className="rtcl-gb-slider-pagination"></div>}
				</div>
			</div>
		) : '',
	]
}

export default StyleGrid;
